<template>
  <div class="main">
    <!-- 菜单 -->
    <my_menu2 page_name="项目详情页" back_icon="md-arrow-back" back_type="back"> </my_menu2>
    <!-- <div class="page_title">
      <span>
        <span class="back_home" @click="bank_home">
          <Icon type="md-arrow-back" />返回首页 &nbsp;|
        </span>
        {{ project_name }} - 项目详情
      </span>

      <div>
        
      </div>
    </div> -->
    <!-- <span class="roster_template_name" title="模板选择后不可修改">当前模板: {{ roster_template_info.name }}</span> -->
    <div style="height:45px">

    </div>


    <div class="div2">



      <project_basic_info ref="project_basic_info" @change="basic_info_change" @location_change="location_change"></project_basic_info>

      <!-- <recruitment_tools ref="recruitment_tools"></recruitment_tools> -->

      <kaipiao ref="kaipiao"></kaipiao>
      <project_payment ref="project_payment"></project_payment>

      <jiezhi_data ref="jiezhi_data"></jiezhi_data>

      <!-- <requirement_data ref="requirement_data"></requirement_data> -->

      <interview_data ref="interview_data"></interview_data>

      <contract_data ref="contract_data"></contract_data>

      <insurance_data ref="insurance_data"></insurance_data>

      <entry_data ref="entry_data"></entry_data>

      <project_setting ref="project_setting"></project_setting>
      

    </div>
  </div>
</template>

<script>
import watermark from "@/utils/shuiyin.js";

import my_menu from "@/component/menu/menu.vue";
import my_menu2 from "@/component/menu/menu2.vue";
import { http, open_new_page } from "@/utils/http.js";
import interview_data from "./component/interview_data.vue";
import contract_data from "./component/contract_data.vue";
import entry_data from "./component/entry_data.vue";
import insurance_data from "./component/insurance_data.vue";
import requirement_data from "./component/requirement_data.vue";
import jiezhi_data from "./component/jiezhi_data.vue";
import kaipiao from "./component/kaipiao.vue";
import project_basic_info from "./component/project_basic_info.vue";
import project_setting from "./component/project_setting.vue";
import project_payment from "./component/payment.vue";
// import recruitment_tools from "./component/recruitment_tools.vue";

export default {
  components: {
    project_basic_info,
    my_menu,
    interview_data,
    contract_data,
    entry_data,
    insurance_data,
    requirement_data,
    jiezhi_data,
    kaipiao,
    project_setting,
    project_payment,
    my_menu2,
    // recruitment_tools,
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度

      //系统列表
      table_data: [],
      columns: [],
      table_loading: false,
      page: 1,
      add_field_show: false,

      project_name: "",
      project_id: "",
    };
  },

  mounted() {
    //  生成水印
    this.create_shuiyin();
    this.window_change();

    var query = this.$route.query;
    // if (query.project_name) {
    //     this.project_name = query.project_name
    // }
    if (query.project_id) {
      this.project_id = query.project_id;
    }

    this.$refs.interview_data.open(this.project_id, this.project_name);
    this.$refs.contract_data.open(this.project_id, this.project_name);
    this.$refs.entry_data.open(this.project_id, this.project_name);
    this.$refs.insurance_data.open(this.project_id, this.project_name);
    // this.$refs.requirement_data.open(this.project_id, this.project_name)
    this.$refs.jiezhi_data.open(this.project_id, this.project_name);
    this.$refs.project_setting.open(this.project_id, this.project_name);
    // this.$refs.recruitment_tools.open(this.project_id, this.project_name);
  },

  methods: {

    location_change(e){
      console.log('location变化',e)
      
    },
   
    basic_info_change(e) {
      console.log(e);
      this.project_name = e.project_name;
      this.$refs.project_payment.open(this.project_id, this.project_name);
    },

    bank_home() {
      open_new_page("/");
    },

    create_shuiyin() {
      var user_info = this.$cookies.get("dx_user_info");
      if (user_info) {
        var name = user_info.name;

        var date = new Date();
        var year = date.getFullYear(); // 获取年
        var month = date.getMonth() + 1; // 获取月
        var strDate = date.getDate();
        var timestr = String(year) + "/" + String(month) + "/" + String(strDate);
        console.log(timestr);
        watermark.set(name + timestr, "0px");
      }
    },

    //获取用户列表
    get_user_list() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      this.table_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/project_interview_data",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.table_data = res.data.table_data;
            that.columns = res.data.columns;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },
  },
};
</script>

<style scoped>
.back_home {
  color: #e2e9f1;
  cursor: pointer;
  margin-right: 10px;
}

.back_home:hover {
  color: #fff;
}

.div2 {
  height: calc(100vh - 60px);
  overflow: auto;
}

.title_text {
  margin: 10px 10px;
  font-size: 14px;
  color: #969696;
  border-bottom: 1px solid #ddd;
  padding: 10px 10px 5px 0px;
  display: flex;
  font-weight: 600;
  justify-content: space-between;
}

.page_title {
  font-weight: 300;
  display: flex;
  align-items: center;
  justify-content: space-between;
  letter-spacing: 3px;
  padding: 0 15px 0 15px;
  background-color: #0466dd;
  color: #fff;
  height: 40px;
  line-height: 40px;
}

.content_page {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
  margin-bottom: 10px;
}

.circular {
  width: 25px;
  height: 25px;
}

.table_box {
  position: relative;
}

.add_sys_button {
  margin-top: 20px;
  text-align: right;
}

.form_item_title {
  flex-shrink: 0;
  width: 100px;
}

.form_item {
  display: flex;
  align-items: center;
}

.options {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.content {
  width: calc(100% - 180px);
  background-color: #fff;
  position: absolute;
  right: 0px;
  top: 0px;
  height: 100vh;
  padding: 10px;
}

.main {
  background: #f5f7f9;
  min-height: 100vh;
  min-width: 900px;
}
</style>
